import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'sourceStreamSettings';
export const useSourceStreamSettingsTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    data_title: 'Данные потока',
    autorestart_title: 'Параметры перезапуска',
    fields: {
      type: 'Тип',
      reference: 'Полный путь к потоку',
      restart: 'Автоматически перезапускать',
    },
    type_options: {
      stream: 'Поток',
      videofile: 'Видеофайл',
    },
    tooltips: {
      type: 'Тип источника видеопотока: UDP, TCP, видеофайл или изображения. Определяет способ передачи данных и стабильность потока.',
      reference: 'В зависимости от выбранного типа: TCP/UDP — сетевой адрес; видеофайл — путь к файлу; изображения — путь к директории.',
    },
    validation: {
      required: 'Обязательное поле',
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    data_title: 'Stream data',
    autorestart_title: 'Restart parameters',
    fields: {
      type: 'Type',
      reference: 'Full stream path',
      restart: 'Restart automatically',
    },
    type_options: {
      stream: 'Stream',
      videofile: 'Video file',
    },
    tooltips: {
      type: 'Stream source type: UDP, TCP, video file or images. Determines the data transfer method and stream stability.',
      reference: 'Depending on the selected type: TCP/UDP — network address; video file — path to the file; images — path to the directory.',
    },
    validation: {
      required: 'Required field',
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    data_title: 'Datos del flujo',
    autorestart_title: 'Parámetros de reinicio',
    fields: {
      type: 'Tipo',
      reference: 'Ruta completa al flujo',
      restart: 'Reiniciar automáticamente',
    },
    type_options: {
      stream: 'Flujo',
      videofile: 'Archivo de video',
    },
    tooltips: {
      type: 'Tipo de fuente del flujo de video: UDP, TCP, archivo de video o imágenes. Determina el método de transferencia de datos y la estabilidad del flujo.',
      reference: 'Según el tipo seleccionado: TCP/UDP — dirección de red; archivo de video — ruta al archivo; imágenes — ruta al directorio.',
    },
    validation: {
      required: 'Campo obligatorio',
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    data_title: 'Dados do fluxo',
    autorestart_title: 'Parâmetros de reinício',
    fields: {
      type: 'Tipo',
      reference: 'Caminho completo para o fluxo',
      restart: 'Reiniciar automaticamente',
    },
    type_options: {
      stream: 'Fluxo',
      videofile: 'Arquivo de vídeo',
    },
    tooltips: {
      type: 'Tipo de fonte do fluxo de vídeo: UDP, TCP, arquivo de vídeo ou imagens. Determina o método de transferência de dados e a estabilidade do fluxo.',
      reference: 'Dependendo do tipo selecionado: TCP/UDP — endereço de rede; arquivo de vídeo — caminho para o arquivo; imagens — caminho para o diretório.',
    },
    validation: {
      required: 'Campo obrigatório',
    },
  },
}) : {}) as Record<string, unknown>;
